export class PatientCenterRequest {
    userName: string;
    userEmail: string;
    urlPatientCenter: string;
    isAtivation: boolean;
}